import { NgModule } from "@angular/core";
import { ExpandHierachyItemDirective } from "./expand-hierachy-item/expand-hierachy-item";
import { TransitionGroupComponent, TransitionGroupItemDirective } from "./transition-group/transiton-group";
@NgModule({
	declarations: [ExpandHierachyItemDirective, TransitionGroupItemDirective, TransitionGroupComponent],
	imports: [],
	exports: [ExpandHierachyItemDirective, TransitionGroupItemDirective, TransitionGroupComponent],
})
export class DirectivesModule {}



// WEBPACK FOOTER //
// ./src/directives/directives.module.ts